import axios from 'axios';
import { toast } from 'react-toastify';
import { handleAuthEvent } from '../utils/LoaderEmitter';


export const axiosRequest = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

const getHeader = () => {
    return { 'Authorization': 'Bearer ' + sessionStorage.getItem('token') };
}

export const getPlatformDetails = async () => {
    try {
        let headers = getHeader();
        if (!headers) {
            throw 'Login'
        }
        let res = await axiosRequest.get('platforms', { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const getClientList = async () => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get('customers?all=true', {headers});
        return res.data['customers'];
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const getFeedbackList = async () => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get('user/feedback', { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const getKpiList = async () => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let params = {
            "clientId": null,
            "startTime": "2021-01-01",
            "endTime": "2023-01-01"
        }
        let res = await axiosRequest.get('user/getActivityLog', { data: params, headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const getClientDetails = async (clientId) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get(`customers/${clientId}`, {headers});
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const getClientUser = async (clientId) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get(`customers/${clientId}/users?all=true`, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const addLicense = async (params, id) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.post(`customers/${id}/licenses`, params, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const removeLicense = async (params, id) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.delete(`customers/${id}/licenses`, { headers, data: params });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const extendLicense = async (params, id) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.put(`customers/${id}/licenses`, params, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const renewLicense = async (params, id) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.post(`/customers/${id}/renew-licenses`, params, { headers });
        return res.data;
    } catch (exception) {
        throw exception;
    }
}

export const deactivateAccount = async (id) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.delete(`customers/${id}`, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const activateAccount = async (id) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.put(`customers/${id}`,{}, {headers});
        return res.data;
    } catch (exception) {
            if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const editClientUser = async (id, userId, params) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.put(`customers/${id}/users/${userId}`, params, { headers });
        return res.status;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const createNewUser = async (params) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.post(`customers`, params, { headers });
        return res.status;
    } catch (exception) {
        throw exception;
    }
}

export const getRolesDetails = async (userType) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get(`roles?roleType=CUSTOMER&userType=PLATFORM`, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const getLoggedInUserDetails = async (cognitoId) => {
        try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get(`users?cognitoId=${cognitoId}`, {headers});
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const getAdminSkills = async () => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get(`skills`, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const getClientSkills = async (id) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get(`customers/${id}/skills`, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}

export const addUser = async (id, params) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.post(`customers/${id}/users`, params, { headers });
        return res.status;
    } catch (exception) {
        throw exception;
    }
}

export const getClientUserSkills = async (userId) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get(`users/${userId}/skills`, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}

export const addClientUserSkills = async (userId, params) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.post(`users/${userId}/skills`, params, { headers });
        return res.status;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}

export const removeClientUserSkills = async (userId, params) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.put(`users/${userId}/skills`, params, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}

export const deactivateClientSkill = async (customerId,subscriptionProductSkillId) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.put(`customers/${customerId}/skills/${subscriptionProductSkillId}`,{},{ headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}

export const getAvailableUsersForDelegation = async () => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get('/users?type=platform', {headers});
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}
export const getCustomerDelegatedUsers = async (customerId) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.get(`/customers/${customerId}/customerDelegatedUsers`, {headers});
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error('Something went wrong');
        return false;
    }
}
export const addCustomerDelegatedUser = async (customerId, params) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.post(`customers/${customerId}/customerDelegatedUsers`, params, { headers });
        return res.status;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}

export const removeCustomerDelegatedUser = async (customerId,userId) => {
    try {
        let headers = getHeader();
        if (!headers) {
            return;
        }
        let res = await axiosRequest.put(`customers/${customerId}/customerDelegatedUsers/${userId}`, {}, { headers });
        return res;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}
export const getFileBrowser = async (containerName) => {
    try {
        let headers = getHeader();
        let res = await axiosRequest.get(`file-explorer/${containerName}/list`, {}, { headers });
        return res.data;
    } catch (exception) {
        if (exception == 'Login' || exception.response.status == 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}

export const getMedinfoBotStats = async (startDate, endDate) => {
    try {
        let headers = getHeader();
        let res = await axiosRequest.get(`analytics/bot-stats?startDate=${startDate}&endDate=${endDate}`, {}, { headers });
        return res.data;
    } catch (exception) {
        if (exception === 'Login' || exception.response.status === 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}

export const getMedinfoExportData = async (startDate, endDate) => {
    try {
        let headers = getHeader();
        let res = await axiosRequest.get(`analytics/bot-stats-export?startDate=${startDate}&endDate=${endDate}`, {}, { headers });
        console.log(res.data)
        return res.data;
    } catch (exception) {
        if (exception === 'Login' || exception.response.status === 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}
export const getGaldermaChatConversation = async (sessionId) => {
    try {
        let headers = getHeader();
        let res = await axiosRequest.get(`analytics/get-chat-transcript/${sessionId}?client=galderma`, {}, { headers });
        return res.data;
    } catch (exception) {
        if (exception === 'Login' || exception.response.status === 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}
export const getGaldermaBotStats = async (startDate, endDate) => {
    try {
        let headers = getHeader();
        let res = await axiosRequest.get(`analytics/bot-stats?startDate=${startDate}&endDate=${endDate}&client=galderma`, {}, { headers });
        return res.data;
    } catch (exception) {
        if (exception === 'Login' || exception.response.status === 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}
export const getGaldermaExportData = async (startDate, endDate) => {
    try {
        let headers = getHeader();
        let res = await axiosRequest.get(`analytics/bot-stats-export?startDate=${startDate}&endDate=${endDate}&client=galderma`, {}, { headers });
        return res.data;
    } catch (exception) {
        if (exception === 'Login' || exception.response.status === 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}

export const uploadDocs = async (data) => {
    try {
        const headers = {
            'Content-Type': 'multipart/form-data',
        };

        let res = await axiosRequest.post(`file-explorer/upload-to-blob`, data, { headers });
        toast.success("Document Uploaded Successfully");
        return res.data;
    } catch (exception) {
        if (exception === 'Login' || exception.response.status === 401) {
            toast.error("Unauthorized Access");
            handleAuthEvent.emit('login', true);
            return false;
        }
        toast.error(exception.response.data.message);
        return false;
    }
}